module.exports = "/shared/fonts/Futura/web/FtraMd-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/Futura/web/FtraMd-webfont.svg
// module id = 36
// module chunks = 13